import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box } from '@mui/material';
import { medicalConditions, pastSurgeriesOptions, medicationOptions } from '../constants/options';

const MedicalHistorySection = ({ formData, setFormData, errors }) => {
  const handleAutocompleteChange = (name, newValue) => {
    setFormData(prev => ({ ...prev, [name]: newValue }));
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 2: Medical History & Medications
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={medicalConditions}
            value={formData.existing_medical_conditions || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('existing_medical_conditions', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Existing Medical Conditions *"
                required
                fullWidth
                error={!!errors.existing_medical_conditions}
                helperText={errors.existing_medical_conditions}
              />
            )}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={pastSurgeriesOptions}
            value={formData.past_surgeries || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('past_surgeries', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Past Surgeries"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={medicationOptions}
            value={formData.current_medications || ''}
            onInputChange={(_, newVal) => handleAutocompleteChange('current_medications', newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Current Medications"
                fullWidth
                placeholder="List any regular medications..."
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MedicalHistorySection;
